import { render, staticRenderFns } from "./DashBoardBox.vue?vue&type=template&id=fffd6938&scoped=true&"
import script from "./DashBoardBox.vue?vue&type=script&lang=js&"
export * from "./DashBoardBox.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardBox.vue?vue&type=style&index=0&id=fffd6938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffd6938",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
